import React from "react";
import EcomHome from "./assets/images/ecom-home.webp";
import EcomDescription from "./assets/images/ecom-description.webp";
import Emily from "./assets/images/emily.webp";
import Jhon from "./assets/images/jhon.webp";
import SolutionSvg from "./assets/images/solutions.svg";
import HomeWireframe from "./assets/images/home-wireframe.webp";
import ProductWireframe from "./assets/images/product-wireframe.webp";
import WishlistWireframe from "./assets/images/wishlist-wireframe.webp";
import PaymentWireframe from "./assets/images/payment-wireframe.webp";
import PrototypeHome from "./assets/images/prototype-home.webp";
import PrototypeHome2 from "./assets/images/prototype-home2.webp";
import Kid from "./assets/images/kid.webp";
import Payment1 from "./assets/images/payment-1.webp";
import Payment2 from "./assets/images/payment-2.webp";
import PriceDrop from './assets/images/price-drop-page.webp';
import WishlistPage from './assets/images/wishlist-page.webp'
import Learnings from "./Learnings";

const EcomProjectBody = () => {
  return (
    <>
      <section className="wrapper productpagebody">
        <section className="ecom-body">
          <div className="container mx-w-1140px">
            <h2 className="text-center fw-medium margin-set fs-56px mb-4">
              Shop Smart, Look Stunning
            </h2>
            <div className="row justify-content-center">
              <div className="col-md-6 my-3">
                <div className="ecom-home-page">
                  <img src={EcomHome} alt="Ecom Home" />
                </div>
                <p className="text-end mt-16x d-block d-md-none">
                        <a href="https://www.figma.com/proto/G6FVwuKkOiDKmcK6PLqW3S/Roar-South?page-id=11%3A137&node-id=54-8&viewport=1553%2C-409%2C0.1&t=83RKmOrtXqpBmk6K-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=54%3A8" target="_blank" className="proto-link">View Prototype</a>
                    </p>
              </div>
              <div className="col-md-6 my-3 d-none d-md-block">
                <div className="ecom-home-page">
                  <img src={EcomDescription} alt="Ecom HomePage" />
                </div>
                <p className="text-end mt-16x">
                        <a href="https://www.figma.com/proto/G6FVwuKkOiDKmcK6PLqW3S/Roar-South?page-id=11%3A137&node-id=54-8&viewport=1553%2C-409%2C0.1&t=83RKmOrtXqpBmk6K-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=54%3A8" target="_blank" className="proto-link">View Prototype</a>
                    </p>
              </div>
            </div>
          </div>
        </section>
        <section className="short-description mb-5">
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-md-6 my-2">
                <h2 className="fs-36px">Product Overview</h2>
              </div>
              <div className="col-md-6 my-2">
                <p className="fs-24 lh-custom">
                  Redesigning of the real Roar South website, focusing on making
                  it more user-friendly and visually engaging. The new design
                  enhances navigation, improves accessibility, and ensures a
                  seamless experience for users.
                </p>
              </div>
            </div>
            <div className="row mt-3 justify-content-center align-items-center">
              <div className="col-md-4 my-2">
                <div className="card card-bg-secondary h-100 pad-30x align-items-center justify-content-center w-305x ms-auto">
                  <h2 className="fs-24 mb-2 fw-normal mb-0">Timeline</h2>
                  <p className="fs-20 fw-normal mb-0">Dec 1 - Dec 14, 2024</p>
                </div>
              </div>
              <div className="col-md-4 my-2">
                <div className="card card-bg-secondary h-100 pad-30x rounded-10x align-items-center justify-content-center w-338x me-auto">
                  <h2 className="fs-24 mb-2 fw-normal mb-0">Role</h2>
                  <p className="fs-20 fw-normal mb-0">
                    UX Researcher, UX Designer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="brief-description my-5">
          <div className="container">
            <h2 className="fs-36px">Pain points</h2>
            <div className="row justify-content-between">
              <div className="col-md-5 mb-2">
                <div className="mini-title my-4">
                  <h2 className="fs-28x fm-soli text-center">User Insight</h2>
                </div>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Fonts are too small.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Interface is cluttered.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Images are not at all good.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 mb-2">
                <div className="mini-title my-4">
                  <h2 className="fs-28x fm-soli text-center">
                    Pain point Analysis
                  </h2>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end flex-wrap">
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Small and inconsistent fonts, causing strain and
                        difficulty in navigating content smoothly.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        A cluttered interface making it hard to find
                        information and negatively impacting the overall user
                        experience.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Unappealing images fail to capture user interest,
                        reducing interaction and making the platform 
                        uninviting.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="persona my-5">
          <div className="container">
            <h1 className="fs-36px mb-4">Persona</h1>
            <div className="row mb-2">
              <div className="col-md-8 my-2">
                <div className="card persona-card p-3 h-100">
                  <h4 className="fs-24 fw-medium">Goals</h4>
                  <ul className="persona-list">
                    <li>
                      Find trendy, office-appropriate outfits that also work for
                      social events.
                    </li>
                    <li>Easily filter products by size, color, and style.</li>
                    <li>
                      Get fast shipping options to receive outfits in time for
                      events.
                    </li>
                  </ul>
                  <h4 className="fs-24 fw-medium">Challenges</h4>
                  <ul className="persona-list">
                    <li>
                      Hard to find high-quality items at affordable prices.
                    </li>
                    <li>
                      Frustrated by slow delivery times when needing an outfit
                      urgently.
                    </li>
                    <li>
                      Complicated return processes discourage future purchases.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 my-2">
                <div className="card persona-card p-3 h-100 justify-content-center align-items-center">
                  <div className="emily-img mb-4">
                    <img src={Emily} alt="Emily" class="img-cover" />
                  </div>
                  <h4 className="fs-24">Emily Johnson</h4>
                  <p className="fs-24 role">Marketing Executive</p>
                </div>
              </div>
            </div>
            <div className="row mb-2 flex-row-reverse">
              <div className="col-md-8 my-2">
                <div className="card persona-card p-3 h-100">
                  <h4 className="fs-24 fw-medium">Goals</h4>
                  <ul className="persona-list">
                    <li>
                      Purchase stylish yet affordable casual wear for everyday
                      use.
                    </li>
                    <li>
                      Find durable clothes that last longer to avoid frequent
                      shopping.
                    </li>
                    <li>Get deals, discounts, and free shipping options.</li>
                  </ul>
                  <h4 className="fs-24 fw-medium">Challenges</h4>
                  <ul className="persona-list">
                    <li>
                      Dislikes complicated checkout processes with too many
                      steps
                    </li>
                    <li>
                      Finds it difficult to determine fabric quality from online
                      images.
                    </li>
                    <li>
                      Often receives misleading product descriptions that don’t
                      match real items.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 my-2">
                <div className="card persona-card p-3 h-100 justify-content-center align-items-center">
                  <div className="emily-img mb-4">
                    <img src={Jhon} alt="Emily" class="img-cover" />
                  </div>
                  <h4 className="fs-24">Michael Carter</h4>
                  <p className="fs-24 role">Freelance Graphic Designer</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="solution my-5">
          <div className="container">
            <div className="row">
              <h2 className="fs-36px mb-4">
                The Solution we came up with
              </h2>
              <div className="col-12">
                <div className="solution-svg img-contain mb-3">
                  <img src={SolutionSvg} alt="Solutions" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container">
            <h2 className="fs-36px mb-4 my-5">Ideation</h2>
            <div className="row justify-content-center">
              <div className="col-md-5 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Home</h2>
                <div className="wireframe-img">
                  <img src={HomeWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-5 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">
                  Product Description
                </h2>
                <div className="wireframe-img">
                  <img src={ProductWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-5 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Wishlist</h2>
                <div className="wireframe-img">
                  <img src={WishlistWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-5 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Payment</h2>
                <div className="wireframe-img">
                  <img src={PaymentWireframe} alt="Wire frame" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container">
            <h2 className="fs-36px mb-4 my-5">Prototype</h2>
            <div className="row mb-4">
              <h2 className="text-center my-4 fs-28 fm-soli">Home</h2>
              <div className="col-md-6 my-3">
                <div className="prototype-img before mb-3">
                  <img src={PrototypeHome} alt="Wire frame" />
                </div>
                <p className="fs-18 mt-2 lh-24px">
                  <strong>Before:</strong> The cluttered interface, poor-quality
                  images, and inconsistent typography made the shopping
                  experience unappealing and hard to navigate.
                </p>
              </div>
              <div className="col-md-6 my-3">
                <div className="prototype-img after mb-3">
                  <img src={PrototypeHome2} alt="Wire frame" />
                </div>

                <p className="fs-18 mt-2 lh-24px">
                  <strong>After:</strong> A clean and structured layout with
                  high-quality images, improved typography, and an engaging
                  product carousel enhances user experience.
                </p>
              </div>
            </div>
            <div className="row mb-4">
              <h2 className="text-center my-4 fs-28 fm-soli">
                Product Description
              </h2>
              <div className="col-md-6 my-3">
                <div className="prototype-img before mb-3">
                  <img src={Kid} alt="Ecom HomePage" />
                </div>
                <p className="fs-18 mt-2 lh-24px">
                  <strong>Before:</strong> The user cannot view the dress from
                  different angles, the product information is cluttered and
                  tiny, and the CTA button is not clear.
                </p>
              </div>
              <div className="col-md-6 my-3">
                <div className="prototype-img after mb-3">
                  <img src={EcomDescription} alt="Ecom HomePage" />
                </div>

                <p className="fs-18 mt-2 lh-24px">
                  <strong>After:</strong> Added multiple dress angles for better
                  visualization, used a dropdown for product details to
                  declutter, and made the CTA button more prominent for better
                  accessibility.
                </p>
              </div>
            </div>
            <div className="row mb-4">
              <h2 className="text-center my-4 fs-28 fm-soli">Payment</h2>
              <div className="col-md-6 my-3">
                <div className="prototype-img before mb-3">
                  <img src={Payment1} alt="Ecom HomePage" />
                </div>
                <p className="fs-18 mt-2 lh-24px">
                  <strong>Before:</strong> The page is cluttered with too many
                  details, the font is not accessible, and payment and address
                  are combined into one page.
                </p>
              </div>
              <div className="col-md-6 my-3">
                <div className="prototype-img after mb-3">
                  <img src={Payment2} alt="Ecom HomePage" />
                </div>

                <p className="fs-18 mt-2 lh-24px">
                  <strong>After:</strong> Separated payment and address into
                  different steps, added a progress indicator for clarity, and
                  improved font and CTA accessibility.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container my-3">
            <h2 className="fs-36px mb-4 my-5">Visual Design</h2>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="text-center my-4 fs-28 fm-soli">Color</h2>
              <div className="col-6 col-md-3 my-3">
                <div className="h-300 rounded-10x visual-design-card card-1">
                  <div className="content p-3">
                    <p className="text-white mb-2 fs-24">Charcoal Black</p>
                    <p className="text-white fs-20 fm-andi">#262831</p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-3 my-3">
                <div className="h-300 rounded-10x visual-design-card card-2">
                  <div className="content p-3">
                    <p className="mb-2 fs-24">White</p>
                    <p className="fs-20 fm-andi">#FFFFFF</p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-2 my-3">
                <div className="h-300 rounded-10x visual-design-card card-3">
                  <div className="content p-3">
                    <p className="text-white mb-2 fs-24">Onyx Gray Gradient</p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-2 my-3">
                <div className="h-300 rounded-10x visual-design-card card-4">
                  <div className="content p-3">
                    <p className="text-white mb-2 fs-24">Light Gray</p>
                    <p className="text-white fs-20 fm-andi">#EFEFEF</p>
                  </div>
                </div>
              </div>
              <div className="col-md-9 my-3">
                <p className="fs-24 lh-28x text-center">
                  Color in UI design enhances user experience, conveys brand
                  identity, creates visual hierarchy, improves accessibility,
                  evokes emotions, and ensures a cohesive and engaging
                  interface.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="typograpy">
          <div className="container">
            <div className="row justify-content-center">
              <h2 className="text-center mb-4 fs-28 fm-soli">Typography</h2>
              <div className="col-md-12">
                <div className="row mx-3 justify-content-center">
                  <div className="col-md-5 my-3">
                    <div className="font-card d-flex align-items-center justify-content-center">
                      <p className="mb-0 fs-32px lh-24x fm-sans">
                        Source Sans 3
                      </p>
                    </div>
                  </div>
                  <div className="col-md-5 my-3">
                    <div className="font-card font-card-2 d-flex align-items-end">
                      <p className="mb-0 fs-32px lh-24x fm-sans">Aa</p>
                    </div>
                  </div>
                  <div className="col-md-9 mt-2">
                    <p className="fs-24 lh-28x text-center">
                      Color in UI design enhances user experience, conveys brand
                      identity, creates visual hierarchy, improves
                      accessibility, evokes emotions, and ensures a cohesive and
                      engaging interface.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container my-3">
            <h2 className="fs-36px mb-4 my-5">Usability Testing</h2>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="my-4 mb-1 fs-28 fm-soli">User: How often are prices updated in this section?</h2>
              <div className="col-md-9 my-3">
               <div className="price-drop-img mx-auto">
                  <img src={PriceDrop} alt="Price Drop Image" />
               </div>
              </div>
              <div className="col-md-8 my-3">
                <p className="fs-24 lh-28x text-center">
                You can easily view the discount products in a separate page with sort and filter option.
                </p>
              </div>
            </div>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="my-4 mb-1 fs-28 fm-soli">User: I think, wishlist is an important one for clothing website.</h2>
              <div className="col-md-9 my-3">
               <div className="price-drop-img mx-auto">
                  <img src={WishlistPage} alt="Price Drop Image" />
               </div>
              </div>
              <div className="col-md-8 my-3">
                <p className="fs-24 lh-28x text-center">
                Added a separate page for wish list and we can add product directly to the cart.
                </p>
              </div>
            </div>
          </div>
        </section>
        <Learnings/>
      </section>
    </>
  );
};

export default EcomProjectBody;
